import { useEffect, useState } from 'react'

/**
 * Custom hook to detect if the screen is below a given width (default 768px).
 */
export function useIsSmallScreen(breakpoint = 768): boolean {
    const [isSmall, setIsSmall] = useState(() => {
        if (typeof window === 'undefined') return false
        return window.innerWidth < breakpoint
    })

    useEffect(() => {
        if (typeof window === 'undefined') return
        const onResize = () => {
            setIsSmall(window.innerWidth < breakpoint)
        }
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [breakpoint])

    return isSmall
}
